<template>
	<div class='container'>

		<div class="content flex flex-center">

			<div :class="{'error': state === 'error'}">{{ flash }}</div>

		</div>

	</div>
</template>

<script>

import { MailApi } from '../api/MailApi'
import { getParameterByName } from '../assets/js/main.js'

export default {
	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data () {
		return {
			state: false,
			sec: 5
		}
	},

	computed: {
		flash () {
			if (this.state === 'success') return 'Confermato correttamente'
			if (this.state === 'error') return 'Il token è erratto, reindirizzamento in ' + this.sec + ' secondi'
		}
	},
	created () {
		var mm = new MailApi()
		var token = getParameterByName('token')

		const setSuccess = () => {
			this.state = 'success'
			window.location.href = '/'
		}

		const timer = () => {
			var self = this
			setInterval(function () {
				self.sec--
			}, 1000)

			setTimeout(function () {
				window.location.href = '/'
			}, 5000)
		}

		const setError = () => {
			this.state = 'error'
			timer()
		}

		if (!token) return setError()

		mm.confirm(token).then(response => {
			setSuccess()
		}).catch(respnonse => {
			setError()
		})
	}
}

</script>

<style scoped>
.container {
	padding-top: 100px;
}

.error {
	margin: 10px 0;
}
</style>
